export default "__VITE_ASSET__e55b43e1__"